/**
 * Component to render embedded video from Vimeo.
 *
 * @usage <VimeoEmbed videoId="12345678" />
 */

import '../../styles/video.css';

export interface VimeoEmbedProps {
  /**
   * Vimeo video ID.
   */
  videoId: string;
}

const vimeoIdRegex = /^[0-9]{9,10}$/;

export const VimeoEmbed: React.FC<VimeoEmbedProps> = ({ videoId }) => {
  if (!vimeoIdRegex.test(videoId)) {
    console.error(`Invalid video ID: ${videoId}`)
    return null
  }
  return (
    <iframe
      allow="fullscreen; picture-in-picture;"
      allowFullScreen
      className="embedded-video"
      src={`https://player.vimeo.com/video/${videoId}?title=0&byline=0&portrait=0`}
    />
  );
};
